module.exports = "https://static.wmbcdn.com/uniweb/images/8ad08afd0be8a0d6bc1b8e8e6c038a3c.svg";